import Extend from 'flarum/common/extenders';
import GlossaryPage from './components/GlossaryPage';
import BooksPage from './components/BooksPage';
import LinksPage from './components/LinksPage';
import StatsPage from './components/StatsPage';
export default [new Extend.Routes().add('glossary', '/glossary', GlossaryPage), new Extend.Routes().add('books', '/books/:category', BooksPage), new Extend.Routes().add('links', '/links/:category', LinksPage), new Extend.Routes().add('stats', '/stats', StatsPage)];